<template>
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0 text-dark" v-show="show">{{message}}</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'greeting',
        props: ['user'],

        data() {
            return {
                greeting: null,
                name: null,
            }
        },

        computed: {
            message() {
                return `${this.greeting}, ${this.name}`;
            },

            show() {
                return this.greeting && this.name;
            }
        },

        mounted() {
            this.getUser();
            this.greet();
        },

        methods: {
            getUser() {
                axios.get('/api/user').then(response => {
                    if (response.data.name) {
                        this.name = response.data.name;
                    }
                })
            },

            greet() {
                // console.log(moment().format(), moment().tz("Europe/Zurich").format());

                let time = moment().format('HH:mm');
                
                if (time >= "00:00" && time <= "11:00") {
                    this.greeting = "Good morning";
                }

                else if (time >= "11:01" && time <= "12:00") {
                    this.greeting = "Good day";
                }

                else if (time >= "12:01" && time <= "17:00") {
                    this.greeting = "Good afternoon";
                }

                else if (time >= "17:01" && time <= "23:59") {
                    this.greeting = "Good evening";
                }
            }
        }
    }

</script>
